module.exports = __webpack_public_path__ + "1405de98bf42cdc4b17e4b067d1689be.svg";